import axios from "../../../../api/axios";

export const visitEntity = async (entityId: string): Promise<void> => {
  try {
    const response = await axios.put<void>(`/football-entities/${entityId}/visited`);
    return response.data;
  } catch (err) {
    throw new Error(`Failed to record entity visit: ${(err as Error).message}`);
  }
};
